import { getMessaging, isSupported, onMessage } from "firebase/messaging";
import app from "../Auth/firebase";

/**
 * Initialize Firebase Cloud Messaging safely
 *
 * Returns:
 *   - Messaging instance if supported
 *   - null if browser doesn't support FCM
 */
export const initializeMessaging = async () => {
  try {
    const supported = await isSupported();

    if (!supported) {
      return null;
    }

    return getMessaging(app);
  } catch (error) {
    return null;
  }
};

/**
 * Receive Notifications While the Website Is Open (Foreground)
 */
export const listenForForegroundMessages = async () => {
  const messagingInstance = await initializeMessaging();

  if (!messagingInstance) return;

  return onMessage(messagingInstance, (payload) => {
    // Foreground message received — handle silently
  });
};